<header>
  <nav tabindex="-1" class="max-w-[1060px] mx-auto">
    <div class="relative p-4 border-b border-black">
      <div class="flex items-center w-full sm:hidden">
        <div class="w-1/6 text-left">
        </div>

        <div class="text-3xl text-center font-serif text-black mb-0 font-normal w-2/3">
          <a routerLink="" class="no-underline">čtidoma.cz</a>
        </div>

        <div class="w-1/6 text-right">
          <app-mobile-search-btn></app-mobile-search-btn>
        </div>
      </div>
      <div class="flex items-center justify-center sm:items-stretch">
        <div class="hidden sm:block">
          <!-- Desktop menu, show/hide based on menu state. -->
          <app-main-menu class="flex sm:space-x-1 xl:space-x-2 flex-wrap justify-center"></app-main-menu>
        </div>
      </div>

      <!-- Native disclosure works on touch before Angular has bootstrapped. -->
      <details class="group sm:hidden">
        <summary class="absolute left-4 top-4 flex h-11 w-11 cursor-pointer list-none items-center justify-center rounded-full text-black hover:bg-orange-800 hover:text-white focus-visible:outline focus-visible:outline-2 [&::-webkit-details-marker]:hidden">
          <span class="sr-only">Main menu</span>
          <svg class="h-6 w-6 group-open:hidden" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
          <svg class="hidden h-6 w-6 group-open:block" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </summary>
        <div id="mobile-menu">
          <app-main-menu [isDesktop]="false" class="block space-y-1 px-2 pb-3 pt-2"></app-main-menu>
        </div>
      </details>

      <app-mobile-search-input></app-mobile-search-input>
    </div>
  </nav>
</header>


<div class="hidden sm:block max-w-[1060px] mx-auto">
  <div class="flex p-6 border-b border-black items-stretch">
    <div class="w-1/4 flex items-center text-xs">
      <app-day-info></app-day-info>
    </div>
    <div class="w-1/2 items-center">
      <div class="text-3xl md:text-4xl lg:text-5xl text-center font-serif text-black mb-0 font-normal">
        <a routerLink="" class="no-underline">čtidoma.cz</a>
      </div>
    </div>
    <div class="w-1/4 flex items-stretch">
      <app-searchform class="flex w-full"></app-searchform>
    </div>
  </div>
</div>

<section class="content">
  <!-- <app-messages></app-messages> -->
  <router-outlet></router-outlet>
</section>

<div class="bg-white">
  <div class="max-w-[1060px] mx-auto p-6">
    <app-ad-position
      [positionName]="AdPositionName.footerboard"
    ></app-ad-position>
  </div>
  <div class="max-w-[1060px] mx-auto p-6 lg:hidden">
    <app-newsletter-subscription></app-newsletter-subscription>
  </div>
</div>


<footer id="footer" class="bg-orange-100 dark:bg-orange-800">
  <div class="max-w-[1060px] mx-auto p-6 bg-orange-100 dark:bg-orange-800">

    <div class="md:flex md:justify-between md:items-center">
      <div class="mb-6 md:mb-0">
        <a href="/" class="flex items-center text-5xl no-underline">
          čtidoma.cz
        </a>
      </div>
      <div class="p-6 bg-white rounded-xl shadow-lg relative text-center font-bold">
        Máte zajímavou informaci? Chcete spolupracovat?<br />
        Kontaktujte šéfredaktora Martina Chalupu: <a href="mailto:chalupa@ctidoma.cz" class="text-orange-800">chalupa@ctidoma.cz</a>
      </div>
    </div>
    <hr class="my-6 border-black sm:mx-auto dark:border-gray-700 lg:my-8" />
    <div class="text-sm font-bold mb-2">© Centa, a.s.</div>
    <div class="text-xs mb-2">
      Jakékoli použití obsahu včetně převzetí, šíření či dalšího užití a zpřístupňování textových či obrazových materiálů bez písemného souhlasu společnosti Centa,a.s. je zakázáno.
      Čtenář svým přihlášením do jakékoli soutěže na našem webu dává souhlas s tím, že v případě, že se stane výhercem této soutěže, může být jeho jméno na webu publikováno.
      Centa, a.s. využívala licenci ČTK a využívá fotografie z <a href="https://cz.depositphotos.com/">Depositphotos</a>.
    </div>
    <div class="text-xs">
      <a routerLink="/stranka/kontakty-2" class="no-underline">Kontakty</a> | <a routerLink="/stranka/eticky-kodex-79182" class="no-underline">Etický kodex</a> | <a href="#" id="open_preferences_center">Spravovat souhlas s nastavením osobních údajů</a>
    </div>
  </div>

</footer>
